"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _Header = _interopRequireDefault(require("./Header/Header"));

var _Select = _interopRequireWildcard(require("./Select.style"));

var _OptionList = _interopRequireDefault(require("./OptionList/OptionList"));

var _selectionChanger = _interopRequireDefault(require("./utils/selectionChanger"));

var _focus = require("./utils/focus");

var _filterOptions = _interopRequireDefault(require("./utils/filterOptions"));

var _Option = require("./Option/Option");

var _Tag = _interopRequireDefault(require("../Tag"));

var ARROW_DOWN = 40;
var ARROW_UP = 38;
var ENTER = 13;
var keyCodes = [ARROW_DOWN, ARROW_UP, ENTER];
var transitionStyles = {
  entering: {
    transition: 'transform 300ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1)',
    opacity: '0',
    transform: 'scaleY(0.6)'
  },
  entered: {
    transition: 'transform 300ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1)',
    opacity: '1'
  },
  exiting: {
    transition: 'transform 300ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1)',
    opacity: '0',
    transform: 'scaleY(0.6)'
  }
};

if (!Element.prototype.scrollIntoViewIfNeeded) {
  Element.prototype.scrollIntoViewIfNeeded = function scrollIntoViewIfNeeded(centerIfNeeded) {
    function makeRange(start, length) {
      return {
        start: start,
        length: length,
        end: start + length
      };
    }

    function coverRange(inner, outer) {
      if (centerIfNeeded === false || outer.start < inner.end && inner.start < outer.end) {
        return Math.max(inner.end - outer.length, Math.min(outer.start, inner.start));
      }

      return (inner.start + inner.end - outer.length) / 2;
    }

    function makePoint(x, y) {
      return {
        x: x,
        y: y,
        translate: function translate(dX, dY) {
          return makePoint(x + dX, y + dY);
        }
      };
    }

    function absolute(elem, pt) {
      while (elem) {
        pt = pt.translate(elem.offsetLeft, elem.offsetTop); // eslint-disable-line no-param-reassign

        elem = elem.offsetParent; // eslint-disable-line no-param-reassign
      }

      return pt;
    }

    var target = absolute(this, makePoint(0, 0));
    var extent = makePoint(this.offsetWidth, this.offsetHeight);
    var elem = this.parentNode;
    var origin;

    while (elem instanceof HTMLElement) {
      // Apply desired scroll amount.
      origin = absolute(elem, makePoint(elem.clientLeft, elem.clientTop));
      elem.scrollLeft = coverRange(makeRange(target.x - origin.x, extent.x), makeRange(elem.scrollLeft, elem.clientWidth));
      elem.scrollTop = coverRange(makeRange(target.y - origin.y, extent.y), makeRange(elem.scrollTop, elem.clientHeight)); // Determine actual scroll amount by reading back scroll properties.

      target = target.translate(-elem.scrollLeft, -elem.scrollTop);
      elem = elem.parentNode;
    }
  };
}

var Select =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Select, _PureComponent);

  function Select(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Select);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Select).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setRef", function (node) {
      _this.node = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleSelect", function () {
      var selectedOptions = _this.state.selectedOptions;

      _this.props.onSelect(_this.props.multiple ? selectedOptions : selectedOptions[0]);

      if (_this.props.clearOnSelect) {
        _this.setState({
          searchValue: ''
        });

        _this.node.querySelector('input').placeholder = '';
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOptionClick", function (option, wasSelected) {
      _this.setState((0, _selectionChanger.default)(option, wasSelected), _this.handleSelect);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleTagClick", function (option) {
      _this.setState((0, _selectionChanger.default)(option, true, false), _this.handleSelect);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOutsideClick", function (_ref) {
      var target = _ref.target;
      if (_this.node.contains(target)) return;

      _this.setState(function (_ref2, _ref3) {
        var selectedOptions = _ref2.selectedOptions;
        var options = _ref3.options;
        return {
          expanded: false,
          searchValue: '',
          focused: (0, _focus.focusSelected)(selectedOptions[0], options)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleInputChange", function (_ref4) {
      var value = _ref4.target.value;

      _this.props.onSearch(value);

      _this.setState(function (state, _ref5) {
        var options = _ref5.options;
        return {
          searchValue: value,
          focused: (0, _focus.nextFocus)(options, -1, value)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleHeaderClick", function () {
      _this.setState(function (_ref6) {
        var expanded = _ref6.expanded;
        return {
          expanded: !expanded
        };
      });

      setTimeout(function () {
        var selectedOption = document.getElementsByClassName('selected-option');
        var unselectedOption = document.getElementsByClassName('unselected-option');

        if (selectedOption.length) {
          selectedOption[0].scrollIntoViewIfNeeded && selectedOption[0].scrollIntoViewIfNeeded();
        } else if (unselectedOption.length) {
          unselectedOption[0].scrollIntoViewIfNeeded && unselectedOption[0].scrollIntoViewIfNeeded();
        }
      }, 100);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleKeyDown", function (e) {
      if (!keyCodes.includes(e.keyCode)) return;
      e.preventDefault();
      var keyCode = e.keyCode,
          target = e.target;

      if (keyCode === ENTER) {
        _this.handleEnter(target);
      } else {
        _this.setState(function (_ref7, _ref8) {
          var focused = _ref7.focused,
              searchValue = _ref7.searchValue;
          var options = _ref8.options;
          return {
            focused: keyCode === ARROW_UP ? (0, _focus.prevFocus)(options, focused, searchValue) : (0, _focus.nextFocus)(options, focused, searchValue)
          };
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleEnter", function (target) {
      var _this$state = _this.state,
          selectedOptions = _this$state.selectedOptions,
          focused = _this$state.focused,
          searchValue = _this$state.searchValue;
      var options = _this.props.options;
      var filteredOptions = (0, _filterOptions.default)(options, searchValue);
      var option = filteredOptions[focused];
      if (!option) return;
      var wasSelected = selectedOptions.find(function (_ref9) {
        var value = _ref9.value;
        return value === option.value;
      });

      _this.setState((0, _selectionChanger.default)(option, wasSelected), _this.handleSelect);

      if (target.tagName === 'INPUT' && !_this.props.mutilpe) {
        target.blur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOptionHover", function (_ref10) {
      var target = _ref10.target;
      if (target.disabled) return;

      _this.setState({
        focused: +target.dataset.index
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clearSelectedOptions", function () {
      _this.setState(function (prevState) {
        return {
          selectedOptions: [],
          expanded: !prevState.expanded
        };
      }, function () {
        _this.props.onSelect(_this.props.clearBtnProps);
      });
    });
    var _expanded = props.expanded,
        autoFocus = props.autoFocus,
        _options = props.options,
        _selectedOptions = props.selectedOptions;
    _this.state = {
      expanded: _expanded || autoFocus,
      selectedOptions: _selectedOptions,
      searchValue: '',
      focused: (0, _focus.focusSelected)(_selectedOptions[0], _options)
    };
    return _this;
  }

  (0, _createClass2.default)(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleOutsideClick);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref11) {
      var selectedOptions = _ref11.selectedOptions;
      if (selectedOptions === this.props.selectedOptions) return;
      this.setState({
        selectedOptions: selectedOptions
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.state.expanded) return;

      if (this.props.search) {
        this.node.querySelector('input').focus();
      } else {
        this.node.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }, {
    key: "render",
    // renderTag = (tag, index) => (
    //   <Tag
    //     draggable={draggable}
    //     onDrop={onDrop}
    //     tagIndex={index}
    //     canClose={true}
    //     onCloseClick={() => handleTagClick(tag)}
    //   >
    //     {tag.label}
    //   </Tag>
    // );
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          expanded = _this$state2.expanded,
          selectedOptions = _this$state2.selectedOptions,
          searchValue = _this$state2.searchValue,
          focused = _this$state2.focused;
      var _this$props = this.props,
          multiple = _this$props.multiple,
          label = _this$props.label,
          search = _this$props.search,
          customOption = _this$props.customOption,
          disabled = _this$props.disabled,
          shouldFilter = _this$props.shouldFilter,
          options = _this$props.options,
          showSearchIcon = _this$props.showSearchIcon,
          loading = _this$props.loading,
          inputClassName = _this$props.inputClassName,
          minWidth = _this$props.minWidth,
          notFoundOption = _this$props.notFoundOption,
          showClearBtn = _this$props.showClearBtn,
          clearBtnProps = _this$props.clearBtnProps,
          autoFocus = _this$props.autoFocus,
          onOptionDrop = _this$props.onOptionDrop,
          draggable = _this$props.draggable,
          showSelectedOnBottom = _this$props.showSelectedOnBottom,
          scrolledToBottomCallback = _this$props.scrolledToBottomCallback,
          optionsClassName = _this$props.optionsClassName;
      var filteredOptions = shouldFilter ? (0, _filterOptions.default)(options, searchValue) : options;
      return _react.default.createElement("div", null, _react.default.createElement(_Select.default, {
        className: "Select",
        innerRef: this.setRef,
        role: "listbox",
        tabIndex: "0",
        onKeyDown: this.handleKeyDown
      }, _react.default.createElement(_Header.default, {
        label: label,
        selectedOptions: draggable ? selectedOptions : (0, _toConsumableArray2.default)(selectedOptions).reverse(),
        disabled: disabled,
        expanded: expanded,
        multiple: multiple,
        onDrop: onOptionDrop,
        draggable: draggable,
        showSelectedOnBottom: showSelectedOnBottom,
        search: search,
        searchValue: searchValue,
        showSearchIcon: showSearchIcon,
        handleInputChange: this.handleInputChange,
        handleHeaderClick: this.handleHeaderClick,
        handleTagClick: this.handleTagClick,
        inputClassName: inputClassName,
        minWidth: minWidth,
        autoFocus: autoFocus
      }), _react.default.createElement(_reactTransitionGroup.Transition, {
        timeout: 300,
        in: expanded
      }, function (state) {
        return state === 'exited' ? null : _react.default.createElement("div", {
          style: (0, _objectSpread2.default)({}, transitionStyles[state])
        }, _react.default.createElement(_OptionList.default, {
          options: filteredOptions,
          selectedOptions: selectedOptions,
          handleOptionClick: _this2.handleOptionClick,
          customOption: customOption,
          focused: focused,
          handleOptionHover: _this2.handleOptionHover,
          loading: loading,
          notFoundOption: notFoundOption,
          showClearBtn: showClearBtn,
          clearBtnProps: clearBtnProps,
          clearSelectedOptions: _this2.clearSelectedOptions,
          scrolledToBottomCallback: scrolledToBottomCallback,
          optionsClassName: optionsClassName
        }));
      })), multiple && (draggable || showSelectedOnBottom) && _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
        className: draggable ? _Select.draggableTagList : _Select.tagList
      }, selectedOptions.map(function (o, index) {
        return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: o.value,
          timeout: 200,
          classNames: "fade"
        }, _react.default.createElement("div", {
          style: {
            marginTop: '8px',
            marginLeft: '8px'
          }
        }, _react.default.createElement(_Tag.default, {
          draggable: draggable,
          onDrop: onOptionDrop,
          tagIndex: index,
          canClose: true,
          onCloseClick: function onCloseClick() {
            return _this2.handleTagClick(o);
          }
        }, o.label)));
      })));
    }
  }]);
  return Select;
}(_react.PureComponent);

Select.defaultProps = {
  expanded: false,
  multiple: false,
  search: false,
  label: '',
  options: [],
  customOption: null,
  disabled: false,
  shouldFilter: true,
  onSearch: function onSearch() {
    return null;
  },
  selectedOptions: [],
  showSearchIcon: true,
  loading: false,
  inputClassName: null,
  minWidth: 200,
  notFoundOption: undefined,
  clearOnSelect: false,
  showClearBtn: false,
  clearBtnProps: {
    id: 'clear'
  },
  autoFocus: false,
  onOptionDrop: function onOptionDrop() {},
  draggable: false,
  showSelectedOnBottom: false,
  optionsClassName: null
};
Select.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape(_Option.optionPropType)),
  expanded: _propTypes.default.bool,
  inputClassName: _propTypes.default.string,
  label: _propTypes.default.string,
  multiple: _propTypes.default.bool,
  search: _propTypes.default.bool,
  customOption: _propTypes.default.func,
  onSelect: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  shouldFilter: _propTypes.default.bool,
  onSearch: _propTypes.default.func,
  selectedOptions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape(_Option.optionPropType)])),
  showSearchIcon: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  minWidth: _propTypes.default.number,
  notFoundOption: _propTypes.default.shape(_Option.optionPropType),
  clearOnSelect: _propTypes.default.bool,
  showClearBtn: _propTypes.default.bool,
  clearBtnProps: _propTypes.default.object,
  autoFocus: _propTypes.default.bool,
  onOptionDrop: _propTypes.default.func,
  draggable: _propTypes.default.bool,
  showSelectedOnBottom: _propTypes.default.bool,
  optionsClassName: _propTypes.default.string
};
var _default = Select;
exports.default = _default;